(function () {

    'use strict';

    angular.module('iplusjs.loadingIndicator', [
        'lodash'
    ])
    .component('iplusjsLoadingIndicator', {
        bindings: {
            type: '@iliType',
            isLoading: '<?iliIsLoading',
            message: '@iliMessage',
            logo: '<iliLogo',
            onClose: '&?iliOnClose'
        },
        templateUrl: 'common/loadingindicator/loadingIndicator.html',
        controller: LoadingIndicatorController,
        controllerAs: 'loadingVm'
    })
    .service('LoadingIndicatorService', LoadingIndicatorService);

    LoadingIndicatorController.$inject = [
        '$rootScope',
        'LoadingIndicatorService'
    ];
    function LoadingIndicatorController($rootScope, LoadingIndicatorService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$postLink = postLink;
        vm.isInProgress = isInProgress;

        function activate() {
            vm.type = vm.type || 'state';
            vm.isClosable = angular.isFunction(vm.onClose);
            vm.loadingMessage = vm.message;
        }

        function onInit() {
            activate();
        }

        function postLink() {
            if (vm.type === 'state') {
                $rootScope.$on('$stateChangeStart', function () {
                    LoadingIndicatorService.addInProgress();
                });
                $rootScope.$on('$stateChangeSuccess', function () {
                    LoadingIndicatorService.removeAllInProgress();
                });
                $rootScope.$on('$stateChangeCancel', function () {
                    LoadingIndicatorService.removeInProgress();
                });
                $rootScope.$on('$stateChangeError', function () {
                    LoadingIndicatorService.removeAllInProgress();
                });
            }
        }

        function isInProgress() {
            return vm.type === 'state' ? LoadingIndicatorService.isInProgress() : vm.isLoading;
        }

    }

    LoadingIndicatorService.$inject = [
        '$rootScope',
        '$log',
        '$timeout',
        'lodash'
    ];
    function LoadingIndicatorService($rootScope, $log, $timeout, _) {
        var that = this,
            inProgress = [];

        that.isInProgress = isInProgress;
        that.addInProgress = addInProgress;
        that.removeInProgress = removeInProgress;
        that.removeAllInProgress = removeAllInProgress;
        that.resetInProgress = resetInProgress;
        function isInProgress() {
            return !!inProgress.length;
        }
        function addInProgress(id, options) {
            $log.debug('LoadingIndicatorService addInProgress');

            options = options || {};

            if (!_.isNil(options.timeout) && id) {
                return $timeout(function () {
                    inProgress.push({
                        id: id,
                        status: true
                    });
                }, options.timeout);
            } else if (id) {
                inProgress.push({
                    id: id,
                    status: true
                });
            } else {
                inProgress.push(true);
            }

        }
        function removeInProgress(id, addInProgressPromise) {
            $log.debug('LoadingIndicatorService removeInProgress');

            if (addInProgressPromise) {
                $timeout.cancel(addInProgressPromise);
            }

            if (id) {
                var idx = _.findIndex(inProgress, { id: id });

                if (idx > -1) {
                    inProgress.splice(idx, 1);
                }
            } else {
                inProgress.splice(-1, 1);
            }

            if (!isInProgress()) {
                $rootScope.$emit('iplusjs:heightChanged');
            }
        }
        function removeAllInProgress() {
            $log.debug('LoadingIndicatorService removeInProgress');
            inProgress = [];

            $rootScope.$emit('iplusjs:heightChanged');
        }
        function resetInProgress() {
            $log.debug('LoadingIndicatorService resetInProgress');
            inProgress.length = 0;
        }
    }

})();
